import { render } from "./MigrationWidget.vue?vue&type=template&id=28edff13&scoped=true"
import script from "./MigrationWidget.vue?vue&type=script&lang=ts"
export * from "./MigrationWidget.vue?vue&type=script&lang=ts"

import "./MigrationWidget.vue?vue&type=style&index=0&id=28edff13&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28edff13"

export default script